import { DaoModel } from '@dynameat/models';
import { FileDownloader } from '@core/helpers';
import { SaleLocation } from './saleLocation';

export class SaleZone extends DaoModel {
  constructor(guid, name, qrCode, saleLocations) {
    super(guid);
    this.name = name || '';
    this.qrCode = qrCode || null;
    this.saleLocations = saleLocations || [];
  }

  static toInstance(props = {}) {
    const saleLocations = SaleLocation.toInstanceList(props.sale_locations);
    return new SaleZone(props.guid, props.name, props.qr_code, saleLocations);
  }

  serialize() {
    return {
      ...super.serialize(),
      name: this.name,
      qr_code: this.qrCode,
      sale_locations: this.saleLocations.map((zone) => zone.serialize()),
    };
  }

  downloadAllQRCodes() {
    const saleLocationQRs = this.saleLocations.map((saleLocation) => saleLocation.qrCode);
    FileDownloader.downloadZipImages(`${this.name}-QRs`, [this.qrCode, ...saleLocationQRs]);
  }
}
